export default __webpack_public_path__ + "static/media/logo@3x.225d2c90.png";